import * as React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import google from '../../google-play.png';
import apple from '../../apple.png';
import discord from '../../discord.svg';
import twitter from '../../twitter.png';
import PulsoidClient from '../../PulsoidClient';
import {PROD_HOST_NAME} from '../../utils/locationUtils';
import {MenuItemContainer} from '../../system/menu';
import {ActionHref, ActionLink, Copy} from '../../system/buttons';
import Form from 'react-bootstrap/Form';
import {
  FeatureDisabler,
  FeatureToggle,
  WELCOME_REFERRAL,
} from '../../system/FeatureDisabler';
import {
  ReferralFeatureDescription,
  WelcomeReferralDescription,
} from '../../system/FeatureDescriptionModal';

export default class Welcome extends React.Component {
  constructor(props) {
    super(props);
    // let pictureSize = "4em";
    // let footer = <div style={{textAlign: "center", paddingTop: "2em"}}><img style={{height: "5em"}} src={footerp}/></div>;
    let footer = <></>;

    const CardTitle = ({children}) => (
      <Card.Title style={{textAlign: 'center'}}>
        <h4>{children}</h4>
      </Card.Title>
    );
    this.client = new PulsoidClient();

    this.state = {};
    this.state = {
      currentCard: window.location.href.includes('thank') ? 0 : 1,
      helpers: [
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Thank you!</CardTitle>
              <p style={{textAlign: 'center'}}>
                <iframe
                  src="https://giphy.com/embed/6nuiJjOOQBBn2"
                  width="480"
                  height="275"
                  frameBorder="0"
                  title={'Congratulations!!'}
                  className="giphy-embed"
                  allowFullScreen
                />
              </p>
              <p style={{textAlign: 'center'}}>Welcome to Pulsoid family. </p>

              <p style={{textAlign: 'center'}}>Thank you for choosing us. </p>

              <p style={{textAlign: 'center'}}>
                <a
                  itemProp="sameAs"
                  target={'_blank'}
                  href="https://twitter.com/pulsoid_app"
                  rel="noopener noreferrer"
                >
                  <img border="0" src={twitter} width="45" alt={'Loading...'} />
                </a>
                <a
                  itemProp="sameAs"
                  target={'_blank'}
                  href="https://discord.gg/wwaHq4d"
                  rel="noopener noreferrer"
                >
                  <img border="0" src={discord} width="50" alt={'Loading...'} />
                </a>
              </p>
              <p style={{textAlign: 'center'}}>
                <a
                  className="twitter-share-button"
                  target={'_blank'}
                  rel="noopener noreferrer"
                  href="https://twitter.com/intent/tweet?text=Stay%20tuned%20to%20see%20my%20real-time%20heart%20rate%20on%20upcoming%20streams%21%0a@pulsoid_app"
                >
                  Share on Twitter
                </a>
              </p>
              {footer}
            </Card.Body>
          </Card>
        ),
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Get a Heart Rate Monitor</CardTitle>

              <div>
                Pulsoid supports chest strap and armband monitors with heart
                rate broadcasting via BLE.
              </div>
              <div>Some of supported devices:</div>
              <ul>
                <li>
                  TOP:{' '}
                  <a
                    href="https://amzn.to/3xKIaop"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Polar H10
                  </a>
                </li>
                <li>
                  <a
                    href="https://amzn.to/3sXwRYJ"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CooSpo H808S
                  </a>
                </li>
                <li>
                  <a
                    href="https://amzn.to/320t0hn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Polar OH1
                  </a>
                </li>
                <li>
                  <a
                    href="https://amzn.to/3fOPYQQ"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Wahoo Fitness TICKR FIT{' '}
                  </a>
                </li>
              </ul>
              <div>
                Not sure about your device? Ask in{' '}
                <a
                  href="https://discord.gg/nqPs5hJ"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Discord
                </a>{' '}
                or email us at support@pulsoid.net
              </div>

              <p style={{textAlign: 'center'}}>
                <ActionHref
                  href={'https://www.blog.pulsoid.net/monitors?from=welcome'}
                  blank={true}
                >
                  Choose a monitor
                </ActionHref>
              </p>

              {footer}
            </Card.Body>
          </Card>
        ),
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Install mobile application and login</CardTitle>
              <div style={{textAlign: 'center', padding: '4px'}}>
                <DirectLink
                  href={'https://pulsoid.net/s/android-app'}
                  text={<img src={google} alt={'google'} />}
                />
                <span> </span>
                <DirectLink
                  href={'https://pulsoid.net/s/ios-app'}
                  text={<img src={apple} alt={'apple'} />}
                />
              </div>
              <div>
                You need the mobile application to collect heart rate data from
                your monitor.
              </div>
              <div>
                Any troubles with connection?{' '}
                <LearnMoreLink
                  link={
                    'https://www.blog.pulsoid.net/post/pulsoid-does-not-work-troubleshooting?from=welcome'
                  }
                />
              </div>
              {footer}
            </Card.Body>
          </Card>
        ),
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Configure widgets</CardTitle>

              <p>
                Open configuration where you can see your default widgets and
                Marketplace. You will find the list of free and BRO widgets on
                page.
              </p>
              <ul style={{listStyleType: 'none'}}>
                <li>
                  <DirectLink
                    href={
                      'https://www.blog.pulsoid.net/post/how-to-configure-bpm-widget-in-pulsoid?from=welcome'
                    }
                    tex={'How to configure BPM widget'}
                  />
                </li>
                <li>
                  <DirectLink
                    href={
                      'https://www.blog.pulsoid.net/post/pulsoid-features-description?from=welcome'
                    }
                    text={'Features description'}
                  />
                </li>
                <li>
                  <DirectLink
                    href={
                      'https://www.blog.pulsoid.net/post/pulsoid-bro-plan-is-out?from=welcome'
                    }
                    text={'Pulsoid advanced features'}
                  />
                </li>
              </ul>
              <p style={{textAlign: 'center'}}>
                <ActionLink to={'/ui/configuration'}>
                  Configure widgets
                </ActionLink>
              </p>
              {footer}
            </Card.Body>
          </Card>
        ),
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Go Live</CardTitle>
              <p>
                Use links from widget Configuration in your streaming software.
                <a
                  href={
                    'https://medium.com/@plsoid/how-to-add-browser-source-in-obs-streamlabs-obs-twitch-studio-xsplit-50a698080497'
                  }
                  rel="noopener noreferrer"
                  target={'_blank'}
                >
                  {' '}
                  How-to article.
                </a>
              </p>
              <p>
                Do not forget to check{' '}
                <a
                  href={'https://pulsoid.net/ui/analytics'}
                  rel="noopener noreferrer"
                  target={'_blank'}
                >
                  {' '}
                  Analytics
                </a>{' '}
                or{' '}
                <a
                  href={'https://pulsoid.net/ui/export'}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  {' '}
                  Export to CSV{' '}
                </a>{' '}
                after the stream.
              </p>
              {footer}
            </Card.Body>
          </Card>
        ),
        () => (
          <Card lg={5}>
            <Card.Body>
              <CardTitle>Connect advanced features</CardTitle>
              <p>
                Get a <WelcomeReferralDescription /> to use advanced features
                and support the project:
              </p>
              <ul>
                <li>Real-time graph</li>
                <li>Games styled widgets</li>
                <li>Animated text widget with ranges</li>
                <li>Custom sound alerts</li>
                <li>Upload own pictures or webcam frames</li>
                <li>Discord webhook integration</li>
                <li>Fitness widgets</li>
                <li>
                  Pair Apple Watch with{' '}
                  <a
                    href="https://www.blog.pulsoid.net/post/pulsoid-x-stromno-partnership-use-apple-watch-with-pulsoid"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Stromno
                  </a>
                </li>
                <li>Export to CSV</li>
                <li>And many more!</li>
              </ul>
              <p style={{textAlign: 'center'}}>
                <ActionHref
                  variant="success"
                  href={PROD_HOST_NAME + '/pricing?from=welcome'}
                >
                  Upgrade to BRO Plan
                </ActionHref>
              </p>
              {this.state.referralUrl && (
                <FeatureDisabler feature={WELCOME_REFERRAL}>
                  <CardTitle>
                    Invite Friend and You Both Get a Week of BRO Plan{' '}
                    <ReferralFeatureDescription />
                  </CardTitle>
                  <Row>
                    <Col>Share the easiest way to stream heart rate:</Col>
                  </Row>

                  <Row>&nbsp;</Row>
                  <Form.Group as={Row}>
                    <Col>
                      <Form.Control value={this.state.referralUrl} readOnly />
                    </Col>
                    <Col>
                      <Copy text={this.state.referralUrl} />
                      &nbsp; &nbsp;
                      <DirectLink
                        href={`https://twitter.com/intent/tweet?text=Add%20real-time%20heart%20rate%20widgets%20to%20your%20stream%20with%20@pulsoid_app%20using%20my%20link%20and%20get%20an%20extra%20week%20of%20premium:%20${this.state.referralUrl}`}
                        text={
                          <img
                            alt="Twitter logo"
                            border="0"
                            src={twitter}
                            width="35"
                          />
                        }
                      />
                      &nbsp;
                      {/*<Help>Read more</Help>*/}
                    </Col>
                  </Form.Group>
                </FeatureDisabler>
              )}
            </Card.Body>
          </Card>
        ),
      ],
    };
  }

  componentDidMount() {
    this.client.getUserInfo().then((user) => this.setState({...user}));
  }

  render() {
    const WelcomeCard = ({value, current, done, onClick}) => {
      let ss = {backgroundColor: 'white'};
      ss.cursor = 'pointer';
      if (current) {
        ss.border = '2px solid #11a2b1';
      }

      return (
        <Col className="p-2" onClick={onClick}>
          <Card className="p-3" style={ss}>
            <Row className="align-items-center">
              <Col xs={9}>
                <div className="font" style={{fontSize: '30px'}}>
                  {value}
                </div>
              </Col>
              <Col xs={1} />
              <Col xs={1}>
                {' '}
                <FontAwesomeIcon
                  size="3x"
                  color={done ? '#11a2b1' : 'grey'}
                  icon={faCheck}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      );
    };

    let streamed = !!this.state.isUserStreamed;
    let loggedIn = !!this.state.isUserLoggedInMobile;
    let premium = this.state.premium ? !!this.state.premium.isPremium : false;

    return (
      <MenuItemContainer title={'Welcome'}>
        <Row>
          <Col lg={5}>
            <WelcomeCard
              value={'Create an account'}
              done
              current={this.state.currentCard === 0}
              onClick={() => this.setState({currentCard: 0})}
            />

            <WelcomeCard
              value={'Get a Heart Rate Monitor'}
              done={streamed}
              current={this.state.currentCard === 1}
              onClick={() => this.setState({currentCard: 1})}
            />

            <WelcomeCard
              value={'Install mobile application'}
              done={streamed || loggedIn}
              current={this.state.currentCard === 2}
              onClick={() => this.setState({currentCard: 2})}
            />

            <WelcomeCard
              value={'Configure widgets'}
              done={streamed}
              current={this.state.currentCard === 3}
              onClick={() => this.setState({currentCard: 3})}
            />

            <WelcomeCard
              value={'Go Live'}
              done={streamed}
              current={this.state.currentCard === 4}
              onClick={() => this.setState({currentCard: 4})}
            />

            <WelcomeCard
              value={
                <FeatureToggle
                  feature={WELCOME_REFERRAL}
                  current={'Connect advanced features'}
                  next={'Invite friends & Get BRO plan'}
                />
              }
              done={premium}
              current={this.state.currentCard === 5}
              onClick={() => this.setState({currentCard: 5})}
            />
          </Col>
          <Col lg={5}>
            <Col className="p-2">
              {this.state.helpers[this.state.currentCard](this.state)}
            </Col>
          </Col>
        </Row>
      </MenuItemContainer>
    );
  }
}

export const LearnMoreLink = ({link}) => (
  <a href={link} rel="noopener noreferrer" target={'_blank'}>
    Learn more.
  </a>
);

export const DirectLink = ({href, text}) => (
  <a href={href} rel="noopener noreferrer" target={'_blank'}>
    {text}
  </a>
);
